<template>
  <v-container class="py-0" :class="bgColor" fluid style="min-height:300px">
    <v-row>
      <v-col cols="12" sm="6" md="4" lg="3" xl="3" align="center" class="align-self-center" v-if="scenes.length < 10">
        <v-btn text depressed dark color="grey" @click="addSceneClick">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3" xl="3" v-for="(s, i) in scenes" :key="i">
        <v-card flat outlined tile @click="onSceneClick(s, i, scenes)">
          <v-list-item>
            <v-list-item-avatar>
              <v-icon class="primary white--text">mdi-play</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="title">{{ convertName(s.name) }}</v-list-item-title>
              <v-list-item-subtitle>
                <span class="subtitle-1">{{$tc('devices', s.action ? Object.values(s.action).length : 0)}}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import User from '@/components/auth/User'
export default {
  name: 'PanelDetailScene',
  mixins: [User],
  props: {
    pie: {
      type: String
    },
    scenes: {
      type: Array
    },
    bgColor: {
      type: String
    }
  },
  methods: {
    onSceneClick(s, i, scenes) {
      this.$emit('sceneClick', s, i, scenes);
    },
    addSceneClick() {
      this.$emit('addSceneClick', this.scenes);
    },
    convertName(sceneId) {
      let config = (this.userDevice[this.pie] || {}).config;
      let name = ((config || {})[sceneId] || {}).name;
      return name || sceneId;
    }
  }
}
</script>